import { App } from '@capacitor/app';
import type { PatientSessionDetails } from '~/api/generated';

const { isAndroid } = usePlatform();

const getRootDirectory = async () => (isAndroid ? (await App.getInfo()).name : '');

const rootDirectory = await getRootDirectory();

const getSessionsDirectory = (sessionId?: PatientSessionDetails['id']): string => {
  const sessionPath = sessionId ? `/${sessionId}` : '';

  return rootDirectory ? `${rootDirectory}/sessions${sessionPath}` : `sessions${sessionPath}`;
};

const getDictationsDirectory = (sessionId?: PatientSessionDetails['id']): string => {
  const sessionPath = sessionId ? `/${sessionId}` : '';

  return rootDirectory ? `${rootDirectory}/dictations${sessionPath}` : `dictations${sessionPath}`;
};

const getPhotosDirectory = (sessionIdOrFilePath?: PatientSessionDetails['id'] | string): string => {
  const path = sessionIdOrFilePath ? `/${sessionIdOrFilePath}` : '';

  return rootDirectory ? `${rootDirectory}/photos${path}` : `photos${path}`;
};

export { getRootDirectory, getSessionsDirectory, getDictationsDirectory, getPhotosDirectory };
